import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPencil = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 15,
	viewBox: "0 0 14 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M0.609628 14.459C0.530658 14.4599 0.452305 14.4451 0.379077 14.4156C0.305849 14.3861 0.239191 14.3424 0.18294 14.287C0.118447 14.2234 0.0688234 14.1464 0.0376166 14.0614C0.00640987 13.9765 -0.00560954 13.8857 0.00241768 13.7956L0.25679 10.6501C0.267698 10.5041 0.331934 10.3671 0.437312 10.2652L9.51265 1.20572C10.0183 0.733014 10.6911 0.479696 11.3835 0.501274C12.0714 0.506602 12.7315 0.77311 13.2298 1.24667C13.7076 1.73651 13.9824 2.38848 13.9992 3.07201C14.0159 3.75554 13.7733 4.42015 13.32 4.9327L4.23648 14.0331C4.13482 14.1342 4.0017 14.1978 3.85903 14.2133L0.667067 14.5L0.609628 14.459ZM1.43018 10.9696L1.25787 13.214L3.50619 13.0092L12.4502 4.06444C12.6246 3.85841 12.7361 3.60674 12.7714 3.33933C12.8067 3.07193 12.7644 2.80002 12.6495 2.55591C12.5346 2.3118 12.3519 2.10575 12.1231 1.96224C11.8943 1.81873 11.6291 1.7438 11.3589 1.74633C11.1813 1.73508 11.0033 1.75975 10.8355 1.81887C10.6677 1.87798 10.5136 1.97033 10.3824 2.09036L1.43018 10.9696Z" })]
});
const ForwardRef = forwardRef(SvgPencil);
export { ForwardRef as ReactComponent };
